import {
    Service
  } from '../../../service.js';
  import {
    env
  } from '../../../env.js';
  
  class UploadDeTarefasService extends Service {
  
    constructor() {
      super()
  
      this.url = env.url + 'importador'
    }

    async planilhaPreview(item) {
        const url = `${this.url}/preview-planilha`
        const response = await super.postWithoutConvertingBody(url, item, false);
        const responseJson = await response.json();
        return responseJson;
      }

    
      async cabecalhosConfigurados(item) {
        const response = await super.postWithoutConvertingBody(this.url, item, false);
        const responseJson = await response.json();
        this.adicionarImportacaoAoPoolling(responseJson);
        if(response.status == 207 || response.status == 400) {
          return {tarefas: responseJson , status: response.status};
        }
        return response;
      }

      async adquirirStatusImportacoes(uuid) {
        const response = await super.get(`${this.url}/execucoes/${uuid}`);
        return response;
      }

      async adicionarImportacaoAoPoolling(responseJson) {
        if (!responseJson || !responseJson.status) return;

        const uuid = responseJson.status.split("/")[1];
        const { poollingStore } = await import('../../../stateManagement/poolling');

        const objetoUpload = {
          uuid: uuid,
          modulo: 'importacao'
        }
        poollingStore.AddRequestPendente(objetoUpload);
      }
  
  }
  
  export const uploadDeTarefasService = new UploadDeTarefasService()
  